import StoreCard from './StoreCard';

export default StoreCard;
